webpackJsonp([85567699863870],{

/***/ 166:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _me = __webpack_require__(98);
	
	var _me2 = _interopRequireDefault(_me);
	
	var _me3 = __webpack_require__(456);
	
	var _me4 = _interopRequireDefault(_me3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ImpressumComponent = function (_React$Component) {
	  _inherits(ImpressumComponent, _React$Component);
	
	  function ImpressumComponent() {
	    _classCallCheck(this, ImpressumComponent);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ImpressumComponent.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      { className: "container container-impressum" },
	      _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h1",
	          null,
	          "Impressum"
	        ),
	        _react2.default.createElement(
	          "h2",
	          null,
	          "Angaben gem\xE4\xDF \xA7 5 TMG"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          _react2.default.createElement("img", { src: _me2.default })
	        ),
	        _react2.default.createElement(
	          "h2",
	          null,
	          "Kontakt"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          _react2.default.createElement("img", { src: _me4.default })
	        ),
	        _react2.default.createElement(
	          "h2",
	          null,
	          "Verantwortlich f\xFCr den Inhalt nach \xA7 55 Abs. 2 RStV"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          _react2.default.createElement("img", { src: _me2.default })
	        ),
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Haftung f\xFCr Inhalte"
	        ),
	        " ",
	        _react2.default.createElement(
	          "p",
	          null,
	          "Als Diensteanbieter sind wir gem\xE4\xDF \xA7 7 Abs.1 TMG f\xFCr eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach \xA7\xA7 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, \xFCbermittelte oder gespeicherte fremde Informationen zu \xFCberwachen oder nach Umst\xE4nden zu forschen, die auf eine rechtswidrige T\xE4tigkeit hinweisen."
	        ),
	        " ",
	        _react2.default.createElement(
	          "p",
	          null,
	          "Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unber\xFChrt. Eine diesbez\xFCgliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung m\xF6glich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen."
	        ),
	        " ",
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Haftung f\xFCr Links"
	        ),
	        " ",
	        _react2.default.createElement(
	          "p",
	          null,
	          "Unser Angebot enth\xE4lt Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb k\xF6nnen wir f\xFCr diese fremden Inhalte auch keine Gew\xE4hr \xFCbernehmen. F\xFCr die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf m\xF6gliche Rechtsverst\xF6\xDFe \xFCberpr\xFCft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar."
	        ),
	        " ",
	        _react2.default.createElement(
	          "p",
	          null,
	          "Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen."
	        ),
	        " ",
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Urheberrecht"
	        ),
	        " ",
	        _react2.default.createElement(
	          "p",
	          null,
	          "Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielf\xE4ltigung, Bearbeitung, Verbreitung und jede Art der Verwertung au\xDFerhalb der Grenzen des Urheberrechtes bed\xFCrfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur f\xFCr den privaten, nicht kommerziellen Gebrauch gestattet."
	        ),
	        " ",
	        _react2.default.createElement(
	          "p",
	          null,
	          "Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Quelle: ",
	          _react2.default.createElement(
	            "a",
	            { href: "https://www.e-recht24.de" },
	            "e-recht24.de"
	          )
	        )
	      )
	    );
	  };
	
	  return ImpressumComponent;
	}(_react2.default.Component);
	
	exports.default = ImpressumComponent;
	module.exports = exports["default"];

/***/ }),

/***/ 177:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(12);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Header = __webpack_require__(16);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(15);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Impressum = __webpack_require__(166);
	
	var _Impressum2 = _interopRequireDefault(_Impressum);
	
	var _logo = __webpack_require__(19);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _SiteConfig = __webpack_require__(6);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Impressum = function (_React$Component) {
	  _inherits(Impressum, _React$Component);
	
	  function Impressum() {
	    _classCallCheck(this, Impressum);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Impressum.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "pagetype-contact site-wrapper" },
	        _react2.default.createElement(_reactHelmet2.default, { title: _SiteConfig2.default.siteTitle }),
	        _react2.default.createElement(_Header2.default, { headerImage: _logo2.default }),
	        _react2.default.createElement(_Impressum2.default, null),
	        _react2.default.createElement(_Footer2.default, { config: _SiteConfig2.default })
	      )
	    );
	  };
	
	  return Impressum;
	}(_react2.default.Component);
	
	exports.default = Impressum;
	module.exports = exports["default"];

/***/ }),

/***/ 98:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 456:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-impressum-jsx-1605715921438-19876e7c66a4083d6e41.js